var React = require('react');

function Storygraph (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M205.8,244.1l32.1-8.6c5.8-1.6,9.3-7.5,7.7-13.5L191.4,19.8c-1.6-5.9-7.7-9.4-13.4-7.8l-32.1,8.6c-5.8,1.6-9.3,7.5-7.7,13.5l54.2,202.2C193.9,242.1,200,245.6,205.8,244.1z","key":0}),React.createElement("path",{"d":"M54.2,243.7c6,0,10.9-4.8,10.9-11.1V23.3c0-6.1-5-11.1-10.9-11.1H20.9c-6,0-10.9,4.8-10.9,11.1v209.4c0,6.1,5,11.1,10.9,11.1H54.2L54.2,243.7z","key":1}),React.createElement("path",{"d":"M120.3,243.7c6,0,10.9-4.8,10.9-11.1V23.3c0-6.1-5-11.1-10.9-11.1H87.1c-6,0-10.9,4.8-10.9,11.1v209.4c0,6.1,5,11.1,10.9,11.1H120.3L120.3,243.7z","key":2})]));
}

Storygraph.defaultProps = {"width":"32px","height":"32px","viewBox":"0 0 256 256","xmlSpace":"preserve"};

module.exports = Storygraph;

Storygraph.default = Storygraph;
